// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.18398 22.041C9.1428 22.2712 8.94139 22.4412 8.70644 22.4414H5.17617L5.17421 22.4434C4.87361 22.4434 4.64335 22.1722 4.69667 21.874L5.39492 17.915H9.91054L9.18398 22.041Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11.7894 7.2627L10.0541 17.1152H5.53749L7.27578 7.2627H11.7894Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.4701 1.94434C21.7704 1.94459 22.0007 2.21576 21.9477 2.51367L21.3197 6.07031C21.2785 6.3005 21.0772 6.47002 20.8422 6.46777H7.41347L8.21425 1.94141H21.4701V1.94434Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M6.60683 6.46582H2.66738C2.36677 6.46582 2.13651 6.19369 2.18984 5.89551L2.81777 2.33984C2.85898 2.10954 3.06016 1.93945 3.29531 1.93945H7.40371L6.60683 6.46582Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-tdesign')
export default class LogoTdesignIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-tdesign',
    }
  }
}
